import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/what-makes-a-good-listing-title';

export default function Example() {
  return (
    <>
      <Head>
        <title>Create A Good Listing Title And Attract Your Audience Like A Pro</title>
        <meta
          name='description'
          content="Don't let potential customers pass by your listings again by catching their attention with the top of search engine listing titles. Here's a quick guide to help you to nail your listing titles like a pro and boost your sales."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/what-makes-a-good-listing-title' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/what-makes-a-good-listing-title' />
        <meta property='og:title' content='Create A Good Listing Title And Attract Your Audience Like A Pro' />
        <meta
          property='og:description'
          content="Don't let potential customers pass by your listings again by catching their attention with the top of search engine listing titles. Here's a quick guide to help you to nail your listing titles like a pro and boost your sales."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-09-13T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-09-13T00:00:00-00:00' />
        <meta property='article:tag' content='-' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
